
import { Component, State, Vue } from 'nuxt-property-decorator';
import { Navigation } from '@/types/initialData';

@Component({})
export default class ContextuallySortedList extends Vue {
  // @ts-ignore
  @State((state) => state.typo3?.initial?.navigation[0] || [])
  navMain: Navigation;

  get sortedCIDList(): string[] {
    const cidElements = document.querySelectorAll('[id^="c"]');
    const cidList = [];
    cidElements.forEach((cidElement) => {
      cidList.push(cidElement.id);
    });
    return cidList;
  }

  get sortedPidList(): number[] {
    const orderedPids = [];

    const queue: Navigation[] = [];
    queue.push(this.navMain);

    let link;
    while ((link = queue.pop())) {
      if (link && link.uid) {
        orderedPids.push(link.uid);
      }
      if (link.children && link.children.length) {
        // Ensure to push children in reverse, as we traverse them with .pop from last to first
        for (let i = link.children.length - 1; i >= 0; --i) {
          queue.push(link.children[i]);
        }
      }
    }

    return orderedPids;
  }
}
